import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class AchievementsController {

	constructor(app) {
		this.app = app;
	}
	show(path, model) {
		model = this.getModel();

		//get page
		let pageId = path.split("/")[0];

		const dataBinder = new DataBinder();
		dataBinder.populate(pageId, model);

		const swapPage = new SwapPage();
		swapPage.swapPage(pageId);
	}
	getModel() {
		const app = this.app;
		const userdata = app.userdata;
		const achievement = app.achievements;

		let earned = 0;
		let total = 0;
		//get all achievements not hidden unless owned by user

		const userAchievements = userdata.achievements || [];
		const allAchievements = achievement.allAchievements.filter(a => !a.isHidden || userAchievements.includes(a.name));

		for (let key in allAchievements) {
			let achievement = allAchievements[key];
			achievement.owned = false;
			for (let j in userAchievements) {
				if (achievement.name == userAchievements[j]) {
					achievement.owned = true;
					var points = Number(achievement.points);
					if (points) earned += points;
				}
			}

			var points = Number(achievement.points);
			if (points) total += points;
		}

		const model = {
			achievements: allAchievements,
			total: total,
			earned: earned
		}

		return model;
	}
}
